import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./financialItemStyle";
import "../Print.css";

type ForeignCurrencyDataProps = {
  foreignCurrencyData: Array<object>;
  foreignCurrencyTotal: string;
  localForeignCurrencyTotal:string;
};

export const ForeignCurrency: FunctionComponent<ForeignCurrencyDataProps> = ({
  foreignCurrencyData,
  foreignCurrencyTotal,
  localForeignCurrencyTotal
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead className={classes.tableRow}>
              <TableRow style={{ height: "3em" }}>
                <TableCell
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "35%" }}
                >
                  Currency
                </TableCell>
                <TableCell
                  align="center"
                  className={classes.foreignHead}
                  // style={{ width: "25%" }}
                >
                  Number of Transactions
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {foreignCurrencyData &&
                foreignCurrencyData.map((data: any) => (
                  <TableRow>
                    <TableCell align="left" className={classes.columnWeight}>
                      {data.currency_name}
                    </TableCell>
                    <TableCell align="center" className={classes.tableContent}>
                      {data.FcurrencyCount}
                    </TableCell>
                    <TableCell align="right" className={classes.columnWeight}>
                      {data.FcurrencyAmount}
                    </TableCell>
                  </TableRow>
                ))}
              <TableRow style={{ height: "3em" }}>
                <TableCell
                  align="left"
                  style={{ borderLeft: "1px solid gray" }}
                >
                  <Typography className={classes.total}>
                    Total Foreign Currency
                  </Typography>
                </TableCell>
                <TableCell align="left" />
                <TableCell
                  align="right"
                  style={{ borderRight: "1px solid gray" }}
                >
                  <Typography className={classes.value}>
                    {foreignCurrencyTotal}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" className={classes.totalCellStyle}>
                  <Typography className={classes.total}>
                    Total Local Currency
                  </Typography>
                </TableCell>
                <TableCell align="left" className={classes.middleTotalcell} />
                <TableCell align="right" className={classes.totalValueCell}>
                <Typography className={classes.value}>{localForeignCurrencyTotal}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {/* <Grid item xs={12}>
        <Grid container>
          <Grid item xs={6}>
            <Typography className={classes.total}>
              Total Foreign Currency
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.value}>
              {foreignCurrencyTotal}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6}>
            <Typography className={classes.total}>
              Total Local Currency
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.value}>0</Typography>
          </Grid>
        </Grid>
      </Grid> */}
    </Grid>
  );
};
